import React, { useEffect } from 'react'
import { Paginator } from '@fs/zion-ui'

export default function DmcPaginator({
  layout,
  allowShowAll,
  maxPageCount,
  pageCount,
  index,
  hideResultsPerPage,
  noScrollTop,
  children,
  countKey,
  setPageCount,
  length,
  setIndex,
  nextTo,
  prevTo,
  columns,
  top,
  topAndBottom,
}) {
  useEffect(() => {
    if (maxPageCount >= 1000) {
      const paginators = document.querySelectorAll(`#paginator-per-page`)
      const newOption = document.createElement('option')
      newOption.value = 1000
      newOption.text = '1000'

      paginators.forEach((paginator) => {
        if (paginator) {
          paginator.options.add(newOption.cloneNode(true))
        }
      })
    }
  }, [maxPageCount])

  return (
    <>
      {(top || topAndBottom) && (
        <Paginator
          layout={layout}
          allowShowAll={allowShowAll}
          maxPageCount={maxPageCount}
          pageCount={pageCount || 10}
          index={index}
          hideResultsPerPage={hideResultsPerPage}
          noScrollTop={noScrollTop}
          countKey={countKey}
          setPageCount={setPageCount}
          length={length}
          setIndex={setIndex}
          nextTo={nextTo}
          prevTo={prevTo}
          columns={columns}
        />
      )}
      {children}
      {!top && (
        <Paginator
          layout={layout}
          allowShowAll={allowShowAll}
          maxPageCount={maxPageCount}
          pageCount={pageCount || 10}
          index={index}
          hideResultsPerPage={hideResultsPerPage}
          noScrollTop={noScrollTop}
          countKey={countKey}
          setPageCount={setPageCount}
          length={length}
          setIndex={setIndex}
          nextTo={nextTo}
          prevTo={prevTo}
          columns={columns}
        />
      )}
    </>
  )
}
